import { CustomUseQueryOptions } from '../types';
import { ApiInstance } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

// Check if the string is a full URL (http/https) or a file key
const isFullUrl = (str: string) => str.startsWith('http://') || str.startsWith('https://');

export const usePreloadImage = (api: ApiInstance, imgFileKey?: string, options?: CustomUseQueryOptions<string>) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    gcTime: 30 * 60 * 1e3, // 30 minutes - allow image URL updates to be picked up
    staleTime: 10 * 60 * 1e3, // 10 minutes
    enabled: enabled && !!imgFileKey,
    queryKey: [queryKey, 'PreloadImage', imgFileKey],
    queryFn: () => {
      return new Promise<string>((resolve, reject) => {
        if (!imgFileKey) return null;
        // If it's already a full URL, use it directly; otherwise get from API
        const src = isFullUrl(imgFileKey) ? imgFileKey : api.base.getFileUrl(imgFileKey!);
        const image = new Image();
        image.src = src;
        image.addEventListener('load', () => resolve(src));
        image.addEventListener('error', reject);
      });
    },
  });
};
